<i18n src="./resources/locales.json"></i18n>

<template>
  <div class="ecs-quick-crm-contact-info">
    <v-progress-circular v-if="!template" indeterminate color="primary" :width="2" :size="20" />
    <div v-else class="grid">
      <div v-for="(field, index) in topFields" :key="index" class="field">
        <div class="content">
          <div v-once class="prop-label">{{ field.customFieldName }}</div>
          <div class="prop-value">{{ field.value }}</div>
        </div>
        <div class="actions">
          <v-tooltip top z-index="9999">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="copyToClipboard(field.customFieldName, field.value)">
                <v-icon> mdi-content-copy </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('copy', { fieldName: field.customFieldName }) }}</span>
          </v-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';

const UNDEFINED_DATE_TIME = '0001-01-01T00:00:00.000+00:00';

export default {
  name: 'EcsQuickCrmContactInfo',

  components: {},

  props: {
    contactId: {
      type: String,
      required: true
    },
    businessProcessId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      isLoading: {
        type: Boolean,
        default: false
      }
    };
  },

  computed: {
    ...mapGetters('CONTACTS', ['getContactV2', 'getCrmTemplate']),

    ...mapGetters('SETTINGS', ['applicationSettings']),

    ...mapGetters('REFERENCES', ['availableTimeZones']),

    cmrContact() {
      return this.getContactV2(this.contactId) || {};
    },

    template() {
      if (!this.contactId || !this.businessProcessId) {
        return {};
      }

      return this.getCrmTemplate(this.contactId, this.businessProcessId);
    },

    topFields() {
      const fields =
        this.template &&
        Object.values(this.template)
          .filter(item => item.visible)
          .filter(item => item.value)
          .sort((i1, i2) => i1.order - i2.order);
      fields.forEach(field => {
        if (field.fieldType === 'DateTime') {
          if (field.value === UNDEFINED_DATE_TIME || !field.value) {
            field.value = '';
            return;
          }
          const format = field.editable ? 'YYYY-MM-DD' : field.format;
          field.value = moment.utc(field.value).format(format);
        } else if (field.fieldType === 'Timespan') {
          field.value = moment(field.value, this.applicationSettings.timeFormat);
        } else if (field.fieldType === 'TimeZonesValue') {
          field.value = (this.availableTimeZones.find(tz => tz.value === field.value) || {}).name;
        }
      });
      return fields;
    }
  },

  created() {
    this.isLoading = true;
    this.requestCrmTemplate({
      contactId: this.contactId,
      businessProcessId: this.businessProcessId
    }).finally(() => {
      this.isLoading = false;
    });
  },

  methods: {
    ...mapActions('CONTACTS', ['requestCrmTemplate']),

    copyToClipboard(label, value) {
      navigator.clipboard
        .writeText(value || '')
        .then(() => {
          this.$root.$emit('snackbar-message', {
            message: this.$t('copySuccess', { label }),
            type: 'success'
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped src="./scoped.scss" lang="scss" />
